import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducer';
import appHistory from '../util/history';
import { locationChangeMiddleware } from '../util/locationChangeMiddleware';
import { actionAddonMiddleware } from '../util/actionAddonMiddleware';
import { checkoutAuthorizationMiddleware } from '../util/checkoutAuthorizationMiddleware';
import eTagMiddleware from '../util/eTagMiddleware';

// If we ever do server-side rendering, the initial state needs to check
// for pre-hydrated data, probably in window.__initialState
export const initialState = {};

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        maxAge: 125
      })
    : compose;

const configureStore = (preloadedState = initialState) => {
  const store = createStore(
    rootReducer(appHistory),
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware,
        routerMiddleware(appHistory),
        locationChangeMiddleware,
        actionAddonMiddleware,
        checkoutAuthorizationMiddleware,
        eTagMiddleware
      )
    )
  );

  // enable HMR for reducers
  if (import.meta.env.DEV) {
    if (import.meta.hot) {
      import.meta.hot.accept('./reducer', module => {
        store.replaceReducer(module.default(appHistory));
      });
    }
  }

  return store;
};

export default configureStore;
